import { Box, Chip, IconButton, Tooltip, Typography } from "@mui/material";

import { Template } from "features/Influencer/ContactList/schema";
import { trackEvent } from "utils/tracking";

import TemplateChip from "./TemplateChip";
import styles from "./styles";

interface Props {
  isFallback?: boolean;
  editDefault: () => void;
  fallbackTemplates: Template[];
}

const DefaultNicheCard = ({
  isFallback,
  editDefault,
  fallbackTemplates,
}: Props) => {
  return (
    <Box
      sx={styles.card}
      onClick={() => {
        trackEvent("VA Onboarding - Edit Fallback Templates Clicked");
        editDefault();
      }}
    >
      <Box sx={{ position: "absolute", top: 10, right: 10 }}>
        <IconButton sx={{ color: "black", fontSize: 13 }}>
          <Box component="i" className="fa-thin fa-pen-line" />
        </IconButton>
      </Box>
      <Box>
        <Typography sx={{ fontFamily: "Open Sans", fontWeight: 400, mb: 2 }}>
          Niche
        </Typography>
        <Chip
          size="small"
          sx={{
            backgroundColor: "#e5eceb",
            fontSize: 14,
            px: 1,
            mb: 3,
          }}
          label={isFallback ? "Others" : "All"}
        />
      </Box>
      <Box>
        <Typography variant="caption" color="textSecondary">
          General Use Templates
          {isFallback && (
            <Tooltip
              enterTouchDelay={0}
              onClick={(e) => e.stopPropagation()}
              slotProps={{
                tooltip: {
                  sx: {
                    color: "black",
                    backgroundColor: "white",
                    border: "1px solid black",
                    borderRadius: 2,
                    p: 2,
                    fontSize: 14,
                  },
                },
              }}
              title={
                <>
                  <strong>General Use Templates</strong> are used when a brand
                  doesn't fall into any of the specific niches listed above. For
                  example, if you save a brand for your Virtual Assistant to
                  contact and it doesn't match any of the predefined niches,
                  this general template will automatically be used.
                </>
              }
            >
              <Box
                sx={{ ml: 1, color: "green.main" }}
                component="i"
                className="fa-solid fa-question-circle"
              />
            </Tooltip>
          )}
        </Typography>
        {fallbackTemplates?.map((template) => (
          <TemplateChip key={template.id} template={template} />
        ))}
        {fallbackTemplates?.length === 0 && (
          <Typography sx={{ color: "warning.main" }}>
            <Box
              component="i"
              className="fa-regular fa-warning"
              sx={{ mr: 1 }}
            />
            No templates set. Click edit to set your templates.
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default DefaultNicheCard;
